function resolveApiUrl() {
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  if (!envUrl) return '';
  try {
    const envHost = new URL(envUrl).hostname;
    if (typeof window !== 'undefined' && window.location.hostname !== envHost) {
      return '';
    }
  } catch {}
  return envUrl;
}

export const API_URL = resolveApiUrl();
